import React, { useId, useState } from 'react';
import PropTypes from 'prop-types';

/** Inline ⓘ that reveals help text on hover, focus, or click; renders nothing without `text`. */
const InfoTooltip = ({ text, label = 'More info' }) => {
    const [open, setOpen] = useState(false);
    const tooltipId = useId();
    if (!text) return null;
    return (
        <span className="group/tip relative inline-flex align-middle">
            <button
                type="button"
                aria-label={label}
                aria-expanded={open}
                aria-describedby={open ? tooltipId : undefined}
                onClick={() => setOpen(o => !o)}
                onBlur={() => setOpen(false)}
                className="touch-expand inline-flex items-center justify-center w-6 h-6 shrink-0 text-fg-subtle hover:text-fg-muted focus-visible:text-fg-muted cursor-help"
            >
                <span className="material-symbols-outlined text-[15px] leading-none">info</span>
            </button>
            <span
                id={tooltipId}
                role="tooltip"
                className={`pointer-events-none absolute left-0 top-[calc(100%+6px)] w-[240px] max-w-[70vw] rounded-lg border border-border bg-surface-elevated p-2.5 text-xs font-normal leading-relaxed text-fg-muted group-hover/tip:block group-focus-within/tip:block ${
                    open ? 'block' : 'hidden'
                }`}
                style={{ zIndex: 60, boxShadow: '0 8px 24px -8px rgba(0,0,0,.7)' }}
            >
                {text}
            </span>
        </span>
    );
};

InfoTooltip.propTypes = {
    text: PropTypes.string,
    label: PropTypes.string,
};

export default InfoTooltip;
